// api
import { fetchApi } from '@/api'
// actions
const cafeteriaDeliveriesAll = (context) => {
  let url = 'cafeteria/deliveries'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_DELIVERIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaDeliveriesForm = (context) => {
  let url = 'cafeteria/deliveries/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_DELIVERIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaDeliveriesShow = (context) => {
  let url = 'cafeteria/deliveries'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_DELIVERIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const cafeteriaDeliveriesCreate = (context) => {
  let url = 'cafeteria/deliveries/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_DELIVERIES_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaDeliveriesUpdate = (context) => {
  let url = 'cafeteria/deliveries'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('CAFETERIA_DELIVERIES_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaDeliveriesDelete = (context, payload) => {
  let url = 'cafeteria/deliveries'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('CAFETERIA_DELIVERIES_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  cafeteriaDeliveriesAll,
  cafeteriaDeliveriesForm,
  cafeteriaDeliveriesShow,
  cafeteriaDeliveriesCreate,
  cafeteriaDeliveriesUpdate,
  cafeteriaDeliveriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/deliveries/actions.js